// extracted by mini-css-extract-plugin
export default {"mediaIcons":"style_mediaIcons__PxzFN","icon":"style_icon__79F-q"};